import { TranslationField } from "~/components/TranslationField";
import { Group } from "~/components/ui/group";
import { Text } from "~/components/ui/text";
import { SidebarButton } from "~/components/Buttons/SidebarButton";
import { useFaqWidget } from "../../../providers/context";
import { FaqSidebarMobile } from "../Sidebar/mobile";
import { ContentFrame } from "../ContentFrame";
import { FaqSpeechButton } from "../Buttons/speech";
import { FaqBookmarkButton } from "../Buttons/bookmark";
import { FaqDownloadButton } from "../Buttons/download";

export function FaqRootMobile(props: { name: string; }) {

	const { setOpenSheet, selected } = useFaqWidget();

	return (
		<>
			<Group class="mb-4" align="center" justify="between">
				<div>
					<Text class="text-sm mb-1 text-left block" size="xl">
						<TranslationField key={selected()?.category.title} />
					</Text>
					<Text class="font-bold text-left" size="xl">
						<TranslationField key={props.name} />
					</Text>
				</div>
				<SidebarButton class="self-start" onClick={() => setOpenSheet(true)} />
			</Group>
			<Group justify="end">
				<FaqSpeechButton />
				<FaqBookmarkButton />
				<FaqDownloadButton />
			</Group>
			<Text class="block mt-8 font-medium" size="xl">
				<TranslationField key={selected()?.question} />
			</Text>
			<ContentFrame />
			<FaqSidebarMobile />
		</>
	);
}